export default "__VITE_ASSET__BQPTOqOg__"